document.addEventListener("DOMContentLoaded", function() {
  const POLLING_INTERVAL = 10;

  setInterval(setFlickityHeight, POLLING_INTERVAL);

  function setFlickityHeight() {
    const slider = document.querySelector(".product-image-container .flickity-viewport");
    const activeSlide = document.querySelector(".product-image-container .flickity-slider .is-selected");

    if (slider && activeSlide) {
      if (slider.style.height === activeSlide.offsetHeight + "px") {
        return;
      }

      slider.style.height = activeSlide.offsetHeight + "px";
    }
  }
});
